/** Default page size for User Management list views (matches Jobs DataTable default options). */
export const USER_MANAGEMENT_DEFAULT_PAGE_SIZE = 10;

/** Covers full tenant role catalog in one GET /roles call (Sieve PageSize). See TROC-104, TROC-205. */
export const ROLE_CATALOG_PAGE_SIZE = 1000;

/** Per-request page size when walking the full user catalog (delegate picker). See TROC-178. */
export const USER_CATALOG_FETCH_PAGE_SIZE = 100;

/** Safety cap on paginated user-catalog fetches (100 × 500 = 50k users). */
export const MAX_USER_CATALOG_PAGES = 500;
